import { Link as RouterLink } from 'react-router-dom';
// material-ui
import { Link } from '@mui/material';
// project imports
import { useAppSelector } from '@/hooks/useAppSelector';
import { getUserHomePath } from '@/utils/role';
import Logo from 'ui-component/Logo';
// ==============================|| MAIN LOGO ||============================== //
const LogoSection = () => {
    const { user } = useAppSelector(({ auth }) => auth);
    return (
        <Link component={RouterLink} to={getUserHomePath(user)} sx={{ textDecoration: 'none' }}>
            <Logo height={50} />
        </Link>
    );
};
export default LogoSection;
